<template>
  <main>
    


    <PageIntro v-if="appLogin === false"
      :heading="'Complete your registration'"
      :body="'<p>To complete your registration please tell us know more about you by entering the following details:</p>'" />
    <PageIntro v-else
      :heading="'Complete your registration'"
      :body="''" />
    <RegistrationAdditional />
    <FooterShout v-if="appLogin === false" :type="'profile'"/>
  </main>
</template>

<script>
  import RegistrationAdditional from '@/components/RegistrationAdditional'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      RegistrationAdditional,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
    methods: {
    handler() {
      window.location = "http://player.celticfc.com/"
    }
    }
  }
</script>
<style lang="scss" scoped>
  .page-intro {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
     margin-top: 30px;;
    margin-bottom: 30px;;
  }
</style>